import LgpdNotice from '@/components/feature/LgpdNotice';
import { useEffect, useState } from 'react';
import { depoimentosPalestra } from '../../mocks/depoimentos';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import FloatingCTA from '@/components/feature/FloatingCTA';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import AnimatedStatCard from '@/components/feature/AnimatedStatCard';

declare const gtag: (command: string, action: string, params?: Record<string, unknown>) => void;

// ─── Quote Form ───────────────────────────────────────────────────────────────

function QuoteForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    empresa: '',
    eventType: '',
    participants: '',
    date: '',
    local: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus('idle');
    try {
      const body = new URLSearchParams();
      Object.entries(formData).forEach(([k, v]) => body.append(k, v));
      const res = await fetch('https://ordem-de-servico.stibpalestrasilenciosasp.com.br/pedido.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', phone: '', empresa: '', eventType: '', participants: '', date: '', local: '', message: '' });
        if (typeof gtag !== 'undefined') {
          gtag('event', 'generate_lead', { event_category: 'Form', event_label: 'Curitiba Quote' });
        }
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setStatus('idle'), 8000);
    }
  };

  const inputClass = 'w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-primary focus:outline-none font-body text-sm text-gray-800 bg-white transition-colors';
  const labelClass = 'block font-body text-sm font-semibold text-gray-700 mb-1.5';

  return (
    <form
      onSubmit={handleSubmit}
      data-readdy-form
      id="cwb-quote-form"
      aria-label="Formulário de orçamento palestra silenciosa Curitiba"
      className="space-y-5"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label htmlFor="cwb-name" className={labelClass}>Nome Completo *</label>
          <input type="text" id="cwb-name" name="name" required value={formData.name} onChange={handleChange} placeholder="Seu nome" className={inputClass} />
        </div>
        <div>
          <label htmlFor="cwb-email" className={labelClass}>E-mail *</label>
          <input type="email" id="cwb-email" name="email" required value={formData.email} onChange={handleChange} placeholder="seu@empresa.com.br" className={inputClass} />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label htmlFor="cwb-phone" className={labelClass}>Telefone / WhatsApp *</label>
          <input type="tel" id="cwb-phone" name="phone" required value={formData.phone} onChange={handleChange} placeholder="(41) 9 9999-9999" className={inputClass} />
        </div>
        <div>
          <label htmlFor="cwb-empresa" className={labelClass}>Empresa / Instituição</label>
          <input type="text" id="cwb-empresa" name="empresa" value={formData.empresa} onChange={handleChange} placeholder="Nome da empresa ou instituição" className={inputClass} />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label htmlFor="cwb-eventType" className={labelClass}>Tipo de Evento *</label>
          <select id="cwb-eventType" name="eventType" required value={formData.eventType} onChange={handleChange} className={inputClass}>
            <option value="">Selecione...</option>
            <option value="Evento Corporativo / Tech">Evento Corporativo / Tech</option>
            <option value="Congresso / Seminário">Congresso / Seminário</option>
            <option value="Feira de Negócios">Feira de Negócios</option>
            <option value="Conferência Multilíngue">Conferência Multilíngue</option>
            <option value="Treinamento Corporativo">Treinamento Corporativo</option>
            <option value="Summit de Inovação">Summit de Inovação</option>
            <option value="Workshop / Capacitação">Workshop / Capacitação</option>
            <option value="Evento Agro / Indústria">Evento Agro / Indústria</option>
            <option value="Outro">Outro</option>
          </select>
        </div>
        <div>
          <label htmlFor="cwb-participants" className={labelClass}>Número de Participantes</label>
          <select id="cwb-participants" name="participants" value={formData.participants} onChange={handleChange} className={inputClass}>
            <option value="">Selecione...</option>
            <option value="Até 50">Até 50</option>
            <option value="50 a 150">50 a 150</option>
            <option value="150 a 300">150 a 300</option>
            <option value="300 a 500">300 a 500</option>
            <option value="500 a 2.000">500 a 2.000</option>
            <option value="Acima de 2.000">Acima de 2.000</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label htmlFor="cwb-date" className={labelClass}>Data do Evento</label>
          <input type="date" id="cwb-date" name="date" value={formData.date} onChange={handleChange} className={inputClass} />
        </div>
        <div>
          <label htmlFor="cwb-local" className={labelClass}>Local / Venue</label>
          <input type="text" id="cwb-local" name="local" value={formData.local} onChange={handleChange} placeholder="Ex.: Expo Unimed, Batel Business..." className={inputClass} />
        </div>
      </div>

      <div>
        <label htmlFor="cwb-message" className={labelClass}>Detalhes do Evento</label>
        <textarea id="cwb-message" name="message" value={formData.message} onChange={handleChange} maxLength={500} rows={4} placeholder="Descreva o evento, número de trilhas simultâneas, idiomas necessários..." className={`${inputClass} resize-none`} />
        <p className="text-xs text-gray-400 mt-1">{formData.message.length}/500</p>
      </div>

      <LgpdNotice kind="orcamento" className="mb-4 col-span-full" />
            <button type="submit" disabled={isSubmitting} className="w-full bg-primary text-white py-4 rounded-full font-body font-bold text-base uppercase tracking-wide hover:bg-opacity-90 transition-all hover:scale-105 whitespace-nowrap cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed">
        {isSubmitting ? 'ENVIANDO...' : 'SOLICITAR ORÇAMENTO GRATUITO'}
      </button>

      {status === 'success' && (
        <p className="text-center text-green-600 font-body text-sm font-semibold" role="status">
          Orçamento enviado! Nossa equipe retorna em até 24 horas.
        </p>
      )}
      {status === 'error' && (
        <p className="text-center text-red-500 font-body text-sm" role="alert">
          Erro ao enviar. Por favor, tente novamente ou ligue: (41) 9 9999-0000
        </p>
      )}
    </form>
  );
}

// ─── FAQ Item ─────────────────────────────────────────────────────────────────

function FAQItem({ question, answer, index }: { question: string; answer: string; index: number }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-gray-100 rounded-2xl overflow-hidden" itemScope itemType="https://schema.org/Question">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-7 py-5 bg-white hover:bg-gray-50 transition-colors cursor-pointer text-left"
        aria-expanded={open}
        id={`faq-cwb-${index}`}
      >
        <h4 className="font-body font-semibold text-secondary text-base leading-snug pr-4" itemProp="name">{question}</h4>
        <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full bg-primary/10">
          <i className={`ri-${open ? 'subtract' : 'add'}-line text-primary text-base`}></i>
        </div>
      </button>
      {open && (
        <div className="px-7 pb-6 bg-white" itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
          <p className="font-body text-gray-600 text-sm leading-relaxed" itemProp="text">{answer}</p>
        </div>
      )}
    </div>
  );
}

// ─── Data ─────────────────────────────────────────────────────────────────────

const TESTIMONIALS = depoimentosPalestra.slice(0, 3).map((d) => ({
  name: d.nome,
  text: d.texto,
  context: d.contexto,
  rating: 5,
}));

const FAQS = [
  {
    question: 'Como funciona a palestra silenciosa na Expo Unimed ou Bourbon Convention em Curitiba?',
    answer: 'Nesses venues, nossa equipe instala transmissores de RF em pontos estratégicos do espaço para garantir cobertura total. Cada participante recebe um fone sem fio com até 10 canais de conteúdo simultâneo. O setup é feito com 2h de antecedência e inclui testes de sinal em toda a área, inclusive em zonas com interferência de estrutura metálica.',
  },
  {
    question: 'Curitiba tem muitos eventos tech — a palestra silenciosa funciona bem nesses contextos?',
    answer: 'Absolutamente. Curitiba é o maior hub tech do Sul do Brasil, e a palestra silenciosa é ideal para eventos como hackathons, summits de inovação, conferências ágeis e meetups de tecnologia. Permite múltiplas trilhas paralelas (frontend, backend, gestão) sem a necessidade de salas separadas, otimizando tempo e budget.',
  },
  {
    question: 'Vocês atendem eventos com exigências de compliance e documentação no Paraná?',
    answer: 'Sim. Emitimos nota fiscal eletrônica, contrato formal e relatório técnico completo. Atendemos FIEP, sindicatos patronais e empresas com rigorosos processos de compliance. Toda a documentação é fornecida em formato digital e físico conforme necessidade do contratante.',
  },
  {
    question: 'Qual a cobertura geográfica em Curitiba e região?',
    answer: 'Atendemos toda a Região Metropolitana de Curitiba: Batel, Água Verde, Centro Cívico, Rebouças, São José dos Pinhais, Pinhais, Colombo, Fazenda Rio Grande e toda a RMC. Para eventos na região de Londrina, Maringá ou Cascavel, consultamos disponibilidade com antecedência.',
  },
  {
    question: 'Qual o prazo mínimo para contratar em Curitiba?',
    answer: 'Recomendamos contato com pelo menos 15 dias de antecedência para eventos de médio e grande porte (acima de 300 participantes). Para eventos menores, podemos atender com 7 dias. Entre em contato pelo formulário ou WhatsApp para verificar disponibilidade da sua data.',
  },
  {
    question: 'Qual o prazo para emissão de nota fiscal e documentação em Curitiba?',
    answer: 'Emitimos nota fiscal eletrônica em até 24h após a contratação. Para eventos que exigem documentação completa para compliance e prestação de contas (contrato, NF-e, relatório técnico), todo o pacote é enviado em até 5 dias úteis após o evento. Atendemos empresas com processos rigorosos de auditoria e licitação.',
  },
  {
    question: 'Vocês atendem eventos agro e industriais em Curitiba e região?',
    answer: 'Sim. Paraná é o estado do agro e da indústria, e atendemos eventos como Agrishow Sul, Feira das Nações, Paralelo do Agro e eventos industriais da FIEP, SINDIMETAL e associações do setor. Nosso sistema funciona em pavilhões industriais de grandes dimensões com cobertura de sinal em até 5.000 m².',
  },
];

const VENUES = [
  { name: 'Expo Unimed Curitiba', icon: 'ri-building-4-line', capacity: '5.000+' },
  { name: 'Bourbon Convention & Spa', icon: 'ri-hotel-line', capacity: '2.000' },
  { name: 'Batel Business Center', icon: 'ri-building-2-line', capacity: '800' },
  { name: 'Slaviero Essential', icon: 'ri-hotel-line', capacity: '600' },
  { name: 'Teatro Guaíra', icon: 'ri-music-2-line', capacity: '1.400' },
  { name: 'FIEP — Complexo Corporativo', icon: 'ri-building-line', capacity: '1.000' },
  { name: 'Radisson Curitiba', icon: 'ri-hotel-line', capacity: '700' },
  { name: 'PUC-PR — Auditório', icon: 'ri-graduation-cap-line', capacity: '400' },
];

// ─── Main Page ────────────────────────────────────────────────────────────────

export default function CuritibaLandingPage() {
  const { ref: heroRef, isVisible: heroVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: statsRef, isVisible: statsVisible } = useScrollAnimation({ threshold: 0.2 });
  const { ref: formRef, isVisible: formVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: benefitsRef, isVisible: benefitsVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: venuesRef, isVisible: venuesVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: testimonialsRef, isVisible: testimonialsVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: faqRef, isVisible: faqVisible } = useScrollAnimation({ threshold: 0.1 });

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://stibpalestrasilenciosasp.com.br';

  useEffect(() => {
    document.title = 'Palestra Silenciosa Curitiba | Eventos Tech, Agro e Corporativos PR | STIB';

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Palestra silenciosa Curitiba: tecnologia de áudio sem fio para eventos tech, agro e corporativos no Paraná. Expo Unimed, Bourbon Convention e toda a RMC. Orçamento gratuito em 24h!'
      );
    }

    const geoPos = document.querySelector('meta[name="geo.position"]');
    if (geoPos) geoPos.setAttribute('content', '-25.4284;-49.2733');
    const geoReg = document.querySelector('meta[name="geo.region"]');
    if (geoReg) geoReg.setAttribute('content', 'BR-PR');
    const geoPlace = document.querySelector('meta[name="geo.placename"]');
    if (geoPlace) geoPlace.setAttribute('content', 'Curitiba');

    const schemas = [
      {
        id: 'cwb-localbusiness',
        data: {
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          name: 'STIB Palestra Silenciosa Curitiba',
          description: 'Aluguel de fones sem fio e sistemas de palestra silenciosa para eventos tech, industriais, agro e corporativos em Curitiba — PR.',
          url: `${siteUrl}/curitiba`,
          telephone: '+55-11-91777-6227',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'São Paulo',
            addressRegion: 'SP',
            addressCountry: 'BR',
          },
          geo: { '@type': 'GeoCoordinates', latitude: -23.5505, longitude: -46.6333 },
          areaServed: { '@type': 'City', name: 'Curitiba' },
        },
      },
      {
        id: 'cwb-breadcrumb',
        data: {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: 'Palestra Silenciosa Curitiba', item: `${siteUrl}/curitiba` },
          ],
        },
      },
      {
        id: 'cwb-faq',
        data: {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: FAQS.map((f) => ({
            '@type': 'Question',
            name: f.question,
            acceptedAnswer: { '@type': 'Answer', text: f.answer },
          })),
        },
      },
    ];

    schemas.forEach(({ id, data }) => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
      const s = document.createElement('script');
      s.id = id;
      s.type = 'application/ld+json';
      s.textContent = JSON.stringify(data);
      document.head.appendChild(s);
    });

    return () => {
      schemas.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, [siteUrl]);

  return (
    <>
      <Header />
      <FloatingCTA />

      {/* ── HERO ──────────────────────────────────────────────────────────── */}
      <section
        ref={heroRef}
        className="relative min-h-screen w-full flex items-center justify-center overflow-hidden"
        aria-label="Palestra Silenciosa Curitiba — Hero"
      >
        <div className="absolute inset-0">
          <img
            src="/img/stib/cidade-curitiba.webp"
            alt="Palestra Silenciosa Curitiba — Eventos tech, agro e corporativos no Paraná"
            title="Palestra Silenciosa Curitiba — STIB"
            className={`w-full h-full object-cover object-top transition-all duration-[1200ms] ${heroVisible ? 'scale-100 opacity-100' : 'scale-105 opacity-0'}`}
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/40 to-black/70"></div>
        </div>

        <div className="absolute top-24 left-0 right-0 z-20">
          <div className="max-w-7xl mx-auto px-6">
            <Breadcrumb
              variant="light"
              items={[
                { label: 'Home', to: '/' },
                { label: 'Cidades', to: '/cidades' },
                { label: 'Palestra Silenciosa Curitiba' },
              ]}
            />
          </div>
        </div>

        <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
          <div
            className={`inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-xs font-semibold uppercase tracking-widest px-5 py-2 rounded-full mb-8 transition-all duration-700 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-line text-primary text-sm"></i>
            </div>
            Curitiba — Paraná
          </div>

          <header>
            <h1
              className={`font-heading font-extrabold text-6xl md:text-8xl text-white mb-6 tracking-tight leading-none lowercase transition-all duration-700 delay-100 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              palestra silenciosa<br />
              <span className="text-primary">curitiba</span>
            </h1>
          </header>

          <p
            className={`font-body font-light text-xl md:text-2xl text-white/85 mb-10 max-w-3xl mx-auto leading-relaxed transition-all duration-700 delay-200 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          >
            Tecnologia de áudio sem fio para eventos tech, congresso médico, agro e
            corporativos em Curitiba. Expo Unimed, Bourbon Convention e toda a RMC.
          </p>

          <div
            className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-700 delay-300 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          >
            <a
              href="/orcamento"
              className="inline-flex items-center gap-3 bg-primary text-white px-10 py-4 rounded-full font-body font-bold text-base uppercase hover:bg-opacity-90 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              SOLICITAR ORÇAMENTO
              <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full">
                <i className="ri-arrow-down-line text-white text-lg"></i>
              </div>
            </a>
            <a
              href="https://wa.me/5541999990000?text=Olá! Preciso de orçamento para palestra silenciosa em Curitiba."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-white/30 text-white px-10 py-4 rounded-full font-body font-semibold text-base hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-green-400 text-xl"></i>
              </div>
              WhatsApp CWB
            </a>
          </div>

          <div
            className={`flex flex-wrap items-center justify-center gap-6 mt-14 transition-all duration-700 delay-400 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          >
            {[
              { icon: 'ri-code-s-slash-line', label: 'Hub tech do Sul do Brasil' },
              { icon: 'ri-building-4-line', label: 'Expo Unimed e Bourbon CWB' },
              { icon: 'ri-timer-line', label: 'Orçamento em 24h' },
            ].map((b) => (
              <div key={b.label} className="flex items-center gap-2 text-white/80 text-sm font-body">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${b.icon} text-primary text-base`}></i>
                </div>
                {b.label}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── STATS ─────────────────────────────────────────────────────────── */}
      <section ref={statsRef} className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
            {[
              { numericValue: 45, suffix: '+', label: 'Empresas Atendidas', icon: 'ri-building-line' },
              { numericValue: 3, suffix: '', label: 'Idiomas Simultâneos', icon: 'ri-translate-2' },
              { numericValue: 5000, suffix: 'm²', label: 'de Cobertura', icon: 'ri-wifi-line' },
            ].map((s, i) => (
              <AnimatedStatCard
                key={i}
                numericValue={s.numericValue}
                suffix={s.suffix}
                label={s.label}
                icon={s.icon}
                delay={i * 100}
                visible={statsVisible}
                numberColor="text-secondary"
                className="p-8 rounded-2xl bg-gradient-to-br from-primary/5 to-secondary/5"
              />
            ))}
          </div>
        </div>
      </section>

      {/* ── FORM + INFO ───────────────────────────────────────────────────── */}
      <section
        id="orcamento"
        ref={formRef}
        className="py-24 bg-gradient-to-br from-gray-50 to-white"
        aria-label="Formulário de orçamento palestra silenciosa Curitiba"
      >
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            {/* Info lateral */}
            <div className={`transition-all duration-700 ${formVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
              <span className="font-body text-primary font-semibold text-xs uppercase tracking-widest mb-4 block">
                Orçamento Gratuito · Retorno em 24 Horas
              </span>
              <h2 className="font-heading font-bold text-5xl md:text-6xl text-secondary mb-6 lowercase leading-tight">
                quanto custa palestra silenciosa em curitiba?
              </h2>
              <p className="font-body text-lg text-gray-600 leading-relaxed mb-10">
                Preencha o formulário ao lado e receba uma proposta personalizada para seu evento
                em Curitiba — com nota fiscal, contrato e suporte técnico incluídos.
              </p>

              <div className="space-y-6 mb-10">
                {[
                  {
                    icon: 'ri-code-s-slash-line',
                    title: 'Especialistas em Eventos Tech em CWB',
                    desc: 'Curitiba é o maior polo tech do Sul do Brasil. Atendemos hackathons, summits de inovação, conferências ágeis e meetups com setup rápido e tecnologia confiável.',
                  },
                  {
                    icon: 'ri-building-4-line',
                    title: 'Expertise na Expo Unimed e Bourbon',
                    desc: 'Operação recorrente nos principais venues de Curitiba. Conhecemos cada detalhe logístico — de pavilhões a salas de meeting — sem surpresas no dia do evento.',
                  },
                  {
                    icon: 'ri-leaf-line',
                    title: 'Eventos Agro e Industriais no PR',
                    desc: 'Paraná lidera o agronegócio nacional. Atendemos Agrishow Sul, feiras do setor industrial e eventos FIEP com cobertura de sinal em pavilhões de até 5.000 m².',
                  },
                  {
                    icon: 'ri-tools-line',
                    title: 'Técnico Presente no Evento',
                    desc: 'Setup completo, testes de cobertura e suporte em tempo real durante todo o seu evento em Curitiba e Região Metropolitana.',
                  },
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-5">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary/10 flex-shrink-0">
                      <i className={`${item.icon} text-primary text-xl`}></i>
                    </div>
                    <div>
                      <h3 className="font-heading font-bold text-secondary text-base mb-1">{item.title}</h3>
                      <p className="font-body text-sm text-gray-500 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="bg-secondary/5 border border-secondary/10 rounded-2xl p-6">
                <p className="font-body text-sm text-gray-600 leading-relaxed">
                  <strong className="text-secondary">Atendimento em Curitiba — 2026:</strong><br />
                  Cobertura de sinal em até 5.000 m² de área aberta<br />
                  Nota fiscal e contrato para prestação de contas<br />
                  Técnico presencial incluso em todos os pacotes
                </p>
              </div>
            </div>

            {/* Formulário */}
            <div className={`bg-white rounded-3xl p-10 border border-gray-100 transition-all duration-700 delay-200 ${formVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary">
                  <i className="ri-send-plane-line text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="font-heading font-bold text-xl text-secondary">Solicite seu Orçamento</h3>
                  <p className="font-body text-xs text-gray-400">Gratuito · Sem compromisso · Resposta em 24h</p>
                </div>
              </div>
              <QuoteForm />
            </div>
          </div>
        </div>
      </section>

      {/* ── BENEFÍCIOS / DIFERENCIAIS CWB ─────────────────────────────────── */}
      <section ref={benefitsRef} className="py-24 bg-secondary text-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="font-body text-primary font-semibold text-xs uppercase tracking-widest mb-4 block">
              Por que escolher a STIB em Curitiba
            </span>
            <h2
              className={`font-heading font-bold text-5xl md:text-6xl lowercase transition-all duration-700 ${benefitsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              feito para o mercado de eventos do paraná
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-code-s-slash-line',
                title: 'Capital Tech do Sul',
                desc: 'Curitiba é o maior hub de tecnologia do Sul. Atendemos summits de inovação, conferências ágeis, hackathons e eventos de startups com tecnologia de áudio de ponta.',
              },
              {
                icon: 'ri-leaf-line',
                title: 'Eventos Agro de Grande Porte',
                desc: 'Paraná é líder nacional em agronegócio. Atendemos feiras, dias de campo e congressos do setor com cobertura em pavilhões de até 5.000 m² de área aberta.',
              },
              {
                icon: 'ri-building-4-line',
                title: 'Expertise na Expo Unimed CWB',
                desc: 'Com capacidade para 5.000+ participantes, a Expo Unimed é o maior venue de CWB. Temos operação especializada para garantir sinal em toda a área dos pavilhões.',
              },
              {
                icon: 'ri-translate-2',
                title: 'Tradução Simultânea em 3 Idiomas',
                desc: 'Essencial para eventos internacionais em Curitiba. Português, inglês e espanhol — sem cabines físicas, com qualidade profissional e custo 60% menor.',
              },
              {
                icon: 'ri-broadcast-line',
                title: 'Múltiplas Trilhas Simultâneas',
                desc: 'Realize até 10 sessões paralelas no mesmo espaço. Ideal para eventos tech com trilhas de frontend, backend e gestão — sem aluguel de salas extras.',
              },
              {
                icon: 'ri-customer-service-2-line',
                title: 'Suporte Técnico no Local',
                desc: 'Técnico dedicado presente do setup ao encerramento em Curitiba. Zero interrupção no seu evento por causa de áudio — garantia de operação contínua.',
              },
            ].map((item, i) => (
              <div
                key={i}
                className={`bg-white/5 border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-500 ${benefitsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary/20 mb-6">
                  <i className={`${item.icon} text-primary text-2xl`}></i>
                </div>
                <h3 className="font-heading font-bold text-white text-lg mb-3">{item.title}</h3>
                <p className="font-body text-white/70 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ESPAÇOS / VENUES ──────────────────────────────────────────────── */}
      <section ref={venuesRef} className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className={`transition-all duration-700 ${venuesVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
              <span className="font-body text-primary font-semibold text-xs uppercase tracking-widest mb-4 block">Onde já atuamos</span>
              <h2 className="font-heading font-bold text-5xl md:text-6xl text-secondary mb-6 lowercase leading-tight">
                principais espaços em curitiba
              </h2>
              <p className="font-body text-lg text-gray-600 leading-relaxed mb-10">
                Já realizamos eventos de <strong>palestra silenciosa em Curitiba</strong> nos principais
                centros de convenções, hotéis e espaços corporativos do Paraná. Conhecemos cada detalhe
                logístico desses venues.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {VENUES.map((v, i) => (
                  <div
                    key={i}
                    className={`flex items-center gap-4 p-4 rounded-xl bg-gray-50 hover:bg-primary/5 transition-all duration-500 ${venuesVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
                    style={{ transitionDelay: `${i * 60}ms` }}
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary/10 flex-shrink-0">
                      <i className={`${v.icon} text-primary text-base`}></i>
                    </div>
                    <div>
                      <p className="font-body font-semibold text-secondary text-sm">{v.name}</p>
                      <p className="font-body text-xs text-gray-400">até {v.capacity} pessoas</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className={`relative h-[520px] rounded-3xl overflow-hidden transition-all duration-700 delay-200 ${venuesVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
              <img
                src="/img/stib/setor-tecnologia.webp"
                alt="Expo Unimed e centros de convenção em Curitiba — Palestra Silenciosa PR"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-secondary/60 to-transparent"></div>
              <div className="absolute bottom-8 left-8 right-8">
                <p className="font-body text-white/80 text-sm mb-2">Atendimento completo em</p>
                <h3 className="font-heading font-bold text-white text-2xl">Curitiba e toda a RMC</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── DEPOIMENTOS ───────────────────────────────────────────────────── */}
      <section
        ref={testimonialsRef}
        className="py-24 bg-gradient-to-br from-gray-50 to-white"
        aria-label="Depoimentos de clientes Curitiba"
        itemScope
        itemType="https://schema.org/ItemList"
      >
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="font-body text-primary font-semibold text-xs uppercase tracking-widest mb-4 block">
              Quem já contratou em Curitiba
            </span>
            <h2
              className={`font-heading font-bold text-5xl md:text-6xl text-secondary lowercase transition-all duration-700 ${testimonialsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              o que dizem nossos clientes
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {TESTIMONIALS.map((t, i) => (
              <div
                key={i}
                className={`bg-white rounded-2xl p-8 border border-gray-100 hover:border-primary/20 transition-all duration-700 hover:-translate-y-1 ${testimonialsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${i * 150}ms` }}
              >
                <div className="flex items-center gap-1 mb-5">
                  {[...Array(t.rating)].map((_, j) => (
                    <i key={j} className="ri-star-fill text-yellow-400 text-base"></i>
                  ))}
                </div>
                <p className="font-body text-gray-600 text-sm leading-relaxed mb-6 italic">
                  "{t.text}"
                </p>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary/10 flex-shrink-0">
                    <span className="font-heading font-bold text-secondary text-lg">{t.name.charAt(0)}</span>
                  </div>
                  <div>
                    <p className="font-heading font-bold text-secondary text-sm">{t.name}</p>
                    {t.context && (
                      <p className="font-body text-xs text-gray-500">{t.context}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FAQ ───────────────────────────────────────────────────────────── */}
      <section
        ref={faqRef}
        className="py-24 bg-white"
        aria-label="Perguntas frequentes palestra silenciosa Curitiba"
        itemScope
        itemType="https://schema.org/FAQPage"
      >
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-14">
            <span className="font-body text-primary font-semibold text-xs uppercase tracking-widest mb-4 block">
              Dúvidas Frequentes
            </span>
            <h2
              className={`font-heading font-bold text-5xl md:text-6xl text-secondary lowercase transition-all duration-700 ${faqVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              faq — curitiba &amp; paraná
            </h2>
          </div>

          <div className={`space-y-4 transition-all duration-700 delay-200 ${faqVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            {FAQS.map((f, i) => (
              <FAQItem key={i} question={f.question} answer={f.answer} index={i} />
            ))}
          </div>
        </div>
      </section>

      {/* ── FINAL CTA ─────────────────────────────────────────────────────── */}
      <section className="relative py-36 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/img/stib/cidade-curitiba.webp"
            alt="Solicite orçamento palestra silenciosa Curitiba"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-secondary/85 via-secondary/70 to-secondary/50"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
            <div className="max-w-2xl">
              <h2 className="font-heading font-bold text-5xl md:text-6xl text-white lowercase leading-tight mb-6">
                pronto para transformar<br />
                seu evento em curitiba?
              </h2>
              <p className="font-body text-lg text-white/80 leading-relaxed">
                <strong className="text-white">Agenda limitada para Curitiba.</strong> Garanta sua data e
                receba orçamento completo em até 24 horas — com nota fiscal e suporte técnico incluídos.
              </p>
            </div>

            <div className="flex flex-col gap-4 flex-shrink-0">
              <a
                href="/orcamento"
                className="inline-flex items-center justify-center gap-3 bg-primary text-white px-12 py-5 rounded-full font-body font-bold text-base uppercase hover:bg-opacity-90 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                VER FORMULÁRIO DE ORÇAMENTO
                <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full">
                  <i className="ri-arrow-up-line text-white text-lg"></i>
                </div>
              </a>
              <a
                href="https://wa.me/5541999990000?text=Olá! Preciso de orçamento para palestra silenciosa em Curitiba."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-3 bg-white text-secondary px-12 py-5 rounded-full font-body font-bold text-base uppercase hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-green-500 text-xl"></i>
                </div>
                FALAR NO WHATSAPP
              </a>
              <Link
                to="/blog"
                className="text-center font-body text-sm text-white/70 hover:text-white underline underline-offset-4 transition-colors cursor-pointer"
              >
                Ler nossos guias sobre Palestra Silenciosa em Curitiba &rarr;
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}